import * as Sentry from '@sentry/react';
import { Route } from 'react-router-dom';

const SentryRoute = Sentry.withSentryRouting(Route);

export default SentryRoute;
